import { useEffect, useRef } from "react";
import { emitDebugEvent } from "@/utils/debug/eventIntegration";

type RouteTrackingOptions = {
  locationPathname: string;
  locationSearch: string;
  userId?: string | number | null;
  skip?: boolean;
};

/**
 * Tracks page loads and route changes for debug events.
 */
export const useDebugRouteTracking = ({
  locationPathname,
  locationSearch,
  userId,
  skip = false,
}: RouteTrackingOptions): void => {
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    if (skip) {
      return;
    }

    const context: Record<string, string | number | boolean | null> = {
      path: locationPathname,
    };

    if (locationSearch) {
      context.search = locationSearch;
    }

    if (userId !== undefined && userId !== null) {
      context.userId = userId.toString();
    }

    if (prevPathRef.current === null) {
      emitDebugEvent("page_view", "PAGE_LOADED", "web", context);
    } else if (prevPathRef.current !== locationPathname) {
      context.from = prevPathRef.current;
      emitDebugEvent("page_view", "ROUTE_CHANGED", "web", context);
    }

    prevPathRef.current = locationPathname;
  }, [locationPathname, locationSearch, userId, skip]);
};
